


































































































































































































































import { Component, Prop, Watch, Ref } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import ResumeRanapStore from "@/store/modules/ResumeRanapStore";

import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import { storeDokter } from "@/store/modules/dokter";
import moment from "moment";
import SuketDirawat from "@/store/modules/SuketDirawat";
import {
  SuketBaseWithRelationship,
  SuketDirawatInterface
} from "@/types/common_surat_keterangan";
import PDFViewer from "@/components/PDFViewer.vue";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    PDFViewer
  }
})
export default class SuketDirawatTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;
  @Ref() pdfEl: any;

  allowedUnit = ["*"];
  suketCategory = EnSuketCategory.Dirawat;
  suketSvc = new CommonSuket(this.suketCategory);
  suketStore = SuketDirawat;

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  nama = this.pasien.nama;
  umur = getAge(formatDMYDate(this.pasien.tgl_lahir))
    .toString()
    .concat(" Th");

  surat_date = moment().format("YYYY-MM-DD");
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;
  alamat_type = "ktp";

  diagnosis = null;
  note = null;
  tglMulai = null;
  tglSelesai = null;
  today = moment().format("YYYY-MM-DD");
  tglMulaiShow = false;
  tglSelesaiShow = false;

  validasi = [v => !!v || "*Kolom ini harus diisi"];
  saving = false;

  mounted() {
    if (!ResumeRanapStore.resume) {
      ResumeRanapStore.getByRegister(this.register);
    }

    this.register_id = this.dataSuket?.register_id || this.register;
    this.pasien_rm = this.dataSuket?.pasien_rm || this.pasien.rm;
    this.unit_id = this.dataSuket?.unit_id || this.user.unit_id;
    this.nama = this.pasien.nama;
    this.umur =
      this.dataSuket?.pasien.umur_th ||
      getAge(formatDMYDate(this.pasien.tgl_lahir))
        .toString()
        .concat(" Th");

    this.surat_date = this.dataSuket?.surat_date || new Date();
    this.signee_user_id =
      this.dataSuket?.signee_user_id || (this.isMedis ? this.user.id : null);
    this.creator_user_id = this.dataSuket?.creator_user_id || this.user.id;
    this.alamat_type = this.dataSuket?.content.alamat_type;

    this.diagnosis = this.dataSuket?.content?.diagnosis;
    this.note = this.dataSuket?.content?.note;
    this.tglMulai =
      this.dataSuket?.content?.tgl_mulai || ResumeRanapStore.resume?.tgl_masuk;
    this.tglSelesai =
      this.dataSuket?.content?.tgl_selesai ||
      ResumeRanapStore.resume?.tgl_keluar;
    this.today = moment().format("YYYY-MM-DD");
    this.tglMulaiShow = false;
    this.tglSelesaiShow = false;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get pasienPekerjaan() {
    return this.pasien?.pekerjaan ?? "-";
  }

  get alamatOptions() {
    const opts = [
      {
        id: "ktp",
        name: this.pasien.alamat,
        category: "Alamat KTP"
      }
    ];

    if (this.pasien.alamat_domisili) {
      opts.push({
        id: "domisili",
        name: this.pasien.alamat_domisili,
        category: "Alamat Domisili"
      });
    }

    return opts;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        alamat_type: this.alamat_type,
        diagnosis: this.diagnosis,
        tgl_mulai: this.tglMulai,
        tgl_selesai: this.tglSelesai,
        note: this.note
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get listDokter() {
    return storeDokter.list;
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const action = this.dataSuket
        ? this.suketSvc.update(this.dataSuket.id, this.input)
        : this.suketSvc.create(this.input);

      action
        .then(() => {
          if (this.canSign) {
            this.showSignatureModal();
          }

          appModule.NoticeDelay("Berhasil Simpan");

          this.close();
          this.suketStore.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.expandInput = false;
  }

  tglMulaiFormat() {
    return this.tglMulai
      ? moment(this.tglMulai, "YYYY-MM-DD").format("DD MMMM YYYY")
      : "";
  }

  tglSelesaiFormat() {
    return this.tglSelesai
      ? moment(this.tglSelesai, "YYYY-MM-DD").format("DD MMMM YYYY")
      : "";
  }

  print() {
    this.pdfEl.print();
  }

  @Watch("dataSuket")
  changeDataSuket(val: SuketBaseWithRelationship<SuketDirawatInterface>) {
    if (val) {
      this.register_id = val.register_id;
      this.pasien_rm = val.pasien_rm.toString();
      this.unit_id = val.unit_id;
      this.nama = val.pasien.nama;
      this.umur = val.pasien.umur_th;
      this.surat_date = val.surat_date;
      this.signee_user_id = val.signee_user_id;
      this.creator_user_id = val.creator_user_id;
      this.alamat_type = val.content.alamat_type;
      this.diagnosis = val.content.diagnosis;
      this.note = val.content.note;
      this.tglMulai = val.content.tgl_mulai;
      this.tglSelesai = val.content.tgl_selesai;
    } else {
      this.register_id = this.register;
      this.pasien_rm = this.pasien.rm;
      this.unit_id = this.user.unit_id;
      this.nama = this.pasien.nama;
      this.umur = getAge(formatDMYDate(this.pasien.tgl_lahir))
        .toString()
        .concat(" Th");
      this.surat_date = null;
      this.signee_user_id = this.isMedis ? this.user.id : null;
      this.creator_user_id = this.user.id;
      this.alamat_type = "ktp";
      this.diagnosis = null;
      this.note = null;
      this.tglMulai = null;
      this.tglSelesai = null;
    }
  }

  get isMedis() {
    return this.user.profesi.toLowerCase() === "dokter";
  }

  @Watch("expandInput")
  changeExpandInput(val: boolean) {
    if (val) {
      if (!this.dataSuket) {
        console.log("expand input", this.isMedis);

        this.signee_user_id = this.isMedis ? this.user.id : null;
        this.tglMulai = ResumeRanapStore.resume?.tgl_masuk ?? null;
        this.tglSelesai = ResumeRanapStore.resume?.tgl_keluar ?? null;
      }
    }
  }
}
